<template>
  <div class="stateInventory responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader title="Purchases" :links="[
        { name: 'home', label: 'Home' },
        { name: 'reports', label: 'Reports' },
        { name: 'financeReport', label: 'Finance' },
        {
          name: 'inventoryPurchase',
          label: 'Purchases',
        },
      ]" @export="exportToCsv" :disableExport="!reportData" />
      <br class="no-print" />
      <ReportFilter class="no-print" :filterByTime="true" @submit-filter="performGetReport" :isLoading="isLoading"
        :percentage="percentageCompleted" :filterBySaleType="false" />
      <div class="report-container">
        <!-- This could be a component -->
        <div class="report-body" v-if="reportData">
          <table id="table-report">
            <thead>
              <tr>
                <th align="left">Purchase Order</th>
                <th align="left">Posted On</th>
                <th align="left">Supplier</th>
                <th align="left">Supplier Inv</th>
                <th align="left">Item</th>
                <th align="left">Batch #</th>
                <th align="left">Group</th>
                <th align="left">Product</th>
                <th align="right">Quantity</th>
                <th align="right">Unit Cost</th>
                <th align="right">Sub Total</th>
                <th align="right">Discount</th>
                <th align="right">Line Total</th>
                <th align="right">Tax</th>
                <th align="right">Delivery</th>
                <th align="right">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr class="report-body__row"></tr>
              <tr v-for="(data, index) of formattedData" :key="index" :class="{ total2: data.isTotal }">
                <td v-if="!data.isTotal">{{ data.purchaseOrder }}</td>
                <td v-else>Totals</td>
                <td>{{ data.date }}</td>
                <td>{{ data.supplier }}</td>
                <td>{{ data.supplierInvoice }}</td>
                <td>{{ data.item }}</td>
                <td class="batch">{{ data.batchId }}</td>
                <td>{{ data.group }}</td>
                <td>{{ data.name }}</td>
                <td align="right"> {{ data.quantity }}</td>
                <td align="right"> {{ Utilities.formatPrice(data.unitCost) }}</td>
                <td align="right"> {{ Utilities.formatPrice(data.subTotal) }}</td>
                <td align="right"> {{ Utilities.formatPrice(data.discount) }}</td>
                <td align="right"> {{ Utilities.formatPrice(data.lineTotal) }}</td>
                <td align="right"> {{ Utilities.formatPrice(data.tax) }}</td>
                <td align="right"> {{ Utilities.formatPrice(data.delivery) }}</td>
                <td align="right"> {{ Utilities.formatPrice(data.total) }}</td>
              </tr>
            </tbody>
            <tr class="skip-export">
              <td colspan="100%">
                <hr class="line1" />
              </td>
            </tr>
            <tr>
              <td colspan="8">Grand Totals</td>
              <td align="right"> {{ reportData.total.quantity }}</td>
              <td align="center"> - </td>
              <td align="right"> {{ Utilities.formatPrice(reportData.total.subTotal) }}</td>
              <td align="right"> {{ Utilities.formatPrice(reportData.total.discount) }}</td>
              <td align="right"> {{ Utilities.formatPrice(reportData.total.lineTotal) }}</td>
              <td align="right"> {{ Utilities.formatPrice(reportData.total.tax) }}</td>
              <td align="right"> {{ Utilities.formatPrice(reportData.total.delivery) }}</td>
              <td align="right"> {{ Utilities.formatPrice(reportData.total.total) }}</td>
            </tr>
            <tr class="skip-export"></tr>
            <tr class="skip-export">
              <td colspan="100%">
                <hr class="line1" />
              </td>
            </tr>

          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/Header/Header.vue";
import ReportHelper from "@/lib/report/index.js";
import { mapActions, mapGetters } from "vuex";
import ReportFilter from "@/components/ReportFilter/ReportFilter";
import Utilities from "@/lib/Utilities";

export default {
  data() {
    return {
      Utilities,
    };
  },
  components: {
    PageHeader,
    ReportFilter,
  },
  created: function () {
    this.setPageTitle("Purchases");
  },
  mounted: function () {
    const today = new Date();
    this.selectedPeriod = {
      from: new Date(new Date().setDate(today.getDate() - 7)),
      to: today,
    };
  },
  computed: {
    ...mapGetters({
      isLoading: "reports/isLoading",
      getData: "reports/getData",
      percentageCompleted: 'reports/percentageCompleted'
    }),
    reportData() {
      return this.getData;
    },
    formattedData() {
      const data = this.reportData;
      let rows = []
      for (let [purchaseOrder, purchaseOrderValue] of Object.entries(data.list)) {
        for (let [itemId, item] of Object.entries(purchaseOrderValue.items)) {
          rows.push(item)
        }
        rows.push({ ...purchaseOrderValue.total, isTotal: true })
      }

      return rows;
    }
  },
  methods: {
    ...mapActions({
      generateReport: "reports/generate",
      clearData: "reports/clearData",
    }),
    performGetReport(filter) {
      let reportType = "inventoryPurchase";
      this.generateReport({
        reportType,
        ...filter,
      });
    },
    exportToCsv() {
      var table = document.getElementById("table-report");
      ReportHelper.exportToExcel(table, "inventoryPurchase");
    },
  },
  beforeDestroy() {
    this.clearData()
  }
};
</script>

<style lang="scss">
@import "./_inventoryPurchase.scss";
